import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type AssetPerformanceLineDataDashboard } from '../services/getAssetPerformanceRegisterData'

export interface flowRegisterAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flowRegisterAssetData: AssetPerformanceLineDataDashboard | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flowRegisterAssetDataState = {
  flowRegisterAssetData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flowRegisterGraphDataState = createSlice({
  name: 'flowRegisterAssetDataState',
  initialState,
  reducers: {
    flowRegisterGraphDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flowRegisterAssetData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flowRegisterGraphDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flowRegisterAssetData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flowRegisterGraphDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flowRegisterAssetData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flowRegisterGraphDataLoadingAction,
  flowRegisterGraphDataUpdateAction,
  flowRegisterGraphDataErrorAction
} = flowRegisterGraphDataState.actions

export default flowRegisterGraphDataState.reducer
